import React from 'react'
import Styled from 'styled-components'
import { LayoutProps } from './props'

export default ({ children }: LayoutProps) => <Root>{children}</Root>

const Root = Styled.div`
  height: 100%;
`
